var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInverterPower = function SvgInverterPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#inverterPower_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.476 9.429a.86.86 0 0 0-.857-.857h-.857V6a1.714 1.714 0 0 0-1.714-1.714H2.905A1.714 1.714 0 0 0 1.19 6v12a1.714 1.714 0 0 0 1.715 1.715h17.143A1.714 1.714 0 0 0 21.762 18V15.43h.857a.857.857 0 0 0 .857-.857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.637 7.986-2.842 3.84h3.717l-2.028 3.652"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inverterPower_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333 0h24v24h-24z"
  })))));
};
export default SvgInverterPower;